var file_upload_viewer_default = {
  "fontElementMap": "feFW0",
  "file_upload_container": "vcYNy",
  "file_upload_link": "IkYAY",
  "file_upload_error_container": "LXKVr",
  "file_upload_file_info": "yvfsV",
  "file_upload_type_icon": "KqzHR",
  "file_upload_status_icon_container": "w2RjJ",
  "file_upload_status_icon": "SeeEH",
  "file_upload_description": "j4s4w",
  "file_upload_name_container": "ivHvo",
  "file_upload_name": "DXPkJ",
  "file_upload_extension": "_49yRz",
  "file_loader_icon": "_5FVGI",
  "file_upload_icon_frame": "AdYiw",
  "file_upload_icon_background": "Ydurd"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
